import React, { Component } from 'react';
import './App.css';
import SearchBar from './components/search_bar';
import YTsearch from 'youtube-api-search';
import VideoList from './components/video_list';
import VideoDetail from './components/video_detail';
import _ from 'lodash';
import 'tachyons';
import 'bootstrap';
import 'jquery'
const API_KEY = 'AIzaSyBykVUStUAN653FFD4EzzEzgM_b-QQ7h5E';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      videos: [], 
      selectedVideo: null
    };
 
   this.videoSearch('miguel de guzman linapacan'); 
 }
  
  videoSearch(term) {
    YTsearch({ key: API_KEY, term: term }, (videos) => {
      this.setState({ 
        videos: videos, 
        selectedVideo: videos[0]
     });
    });  
   }
   
  
  render() {
    
    const videoSearch = _.debounce((term) => { this.videoSearch(term) }, 300);

    return (
      <div>
          <h1 className='tc'>YouTube Channel Prototype</h1>
          <SearchBar 
            onSearchTermChange={videoSearch}
            className='search-bar'
          />
          <div className="container">
            <VideoDetail className='tc' video={this.state.selectedVideo} />
            <VideoList 
            onVideoSelect={ selectedVideo => this.setState({selectedVideo}) }
            videos={this.state.videos}
           />
          </div> 
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js